import type { ControllerRenderProps } from 'react-hook-form';

import type { QuickAddItemBase, SyncQuickAddSectionProps } from './types';

import { NoDataMessage } from '../no-data-message';
import { SortableList } from '../sortable-list';

export function SortableItemsList<T extends QuickAddItemBase>({
  values,
  field,
  isEditable = false,
  emptyDataMessage,
  removeItem,
  renderItem,
}: {
  values: T[];
  field: ControllerRenderProps;
  isEditable: boolean;
  emptyDataMessage: string;
  removeItem: (item: T) => void;
  renderItem: SyncQuickAddSectionProps<T>['renderItem'];
}) {
  // TODO: FIX THE GLITCH OF DOUBLE RENDER WHEN SORTING
  return (
    <div className="flex flex-col">
      {values.length > 0 ? (
        <SortableList
          items={values}
          renderItem={(item, index) => renderItem(item, { index, isEditable, removeItem })}
          onChange={field.onChange}
        />
      ) : (
        <NoDataMessage message={emptyDataMessage} />
      )}
    </div>
  );
}
